import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Roles } from 'src/app/shared/enums/Roles.enum';

@Component({
  selector: 'app-investor-account-approved-dialog',
  templateUrl: './investor-account-approved-dialog.component.html',
  styleUrls: ['./investor-account-approved-dialog.component.scss'],
})
export class InvestorAccountApprovedComponent implements OnInit {
  @Input() role: Roles | string;

  constructor(private router: Router, public dialogRefModal: MatDialogRef<InvestorAccountApprovedComponent>) {}

  ngOnInit(): void {}

  goToDeposit() {
    this.router.navigateByUrl('/financial-transactions/deposit');
  }

  get title(): string {
    const role = this.role === Roles.CLIENT ? 'cliente' : 'inversionista';
    return `¡Tu perfil de ${role} está activo!`;
  }

  get subtitle(): string {
    return this.role === Roles.CLIENT
      ? 'Sube tu factura o realiza el seguimiento de tu factura hasta el desembolso'
      : 'Ya puedes empezar a invertir en operaciones de Factoring o Confirming';
  }
}
